import $ from "jquery";

export const Result = function () {
	if (!($(".result-page").length > 0)) return false;

	const $elms = {
		shareButton: $(".js-share-button"),
		sharePopup: $("#sharePopup"),
		shareUrl: $("#shareUrl"),
		copyButton: $(".copy-button"),
		closePopup: $(".js-close-popup"),
		layoutSelector: $(".role-starter--homepage"),
		fillDark: $(".filldark"),
		fillTransparent: $(".filltransparent"),
		roleCardNavigationItem: $(".js-role-card-navigation-item"),
		spiderChartPhase: $(".js-spider-chart-phase"),
		legendItems: {
			yourProfile: $("#legend-your-profile"),
			yourMissionGoals: $("#legend-your-mission-goals"),
			old: $("#legend-old"),
			growth: $("#legend-growth"),
			optionalGrowth: $("#legend-optional-growth"),
			coach: $("#legend-coach"),
			military: $("#legend-military"),
			social: $("#legend-social"),
			buddy: $("#legend-buddy"),
		},

		roleInfoBtn: $(".js-role"),
		roleCardPopup: $(".js-role-card-popup"),
		roleCardPopupClose: $(".js-role-card-popup-close"),
	};

	const gradientColorDark = $elms.layoutSelector.attr(
		"data-gradient-color-dark",
	);
	const gradientColorLight = $elms.layoutSelector.attr(
		"data-gradient-color-light",
	);

	if (gradientColorDark && gradientColorLight) {
		$elms.fillDark.css("fill", gradientColorDark);
		$elms.fillTransparent.css("fill", gradientColorLight);
	}

	$elms.roleInfoBtn.on("click", function () {
		const learningGoalId = $(this).attr("data-learning-goal-id");
		const learningGoalColor = $(this).attr("data-color");
		$elms.roleCardPopup.removeClass("is-active");
		$elms.roleCardPopup
			.filter(`[data-learning-goal-id="${learningGoalId}"]`)
			.css("background-color", learningGoalColor)
			.addClass("is-active");
	});

	$elms.roleCardPopupClose.on("click", function () {
		$elms.roleCardPopup.removeClass("is-active");
	});

	// Function to toggle legend items based on data attributes
	const toggleLegendItems = function ($navigationItem) {
		const dataAttributes = {
			yourProfile: $navigationItem.attr("data-has-your-profile"),
			yourMissionGoals: $navigationItem.attr("data-has-your-mission-goals"),
			// old: $navigationItem.attr("data-has-old"),
			growth: $navigationItem.attr("data-has-growth"),
			optionalGrowth: $navigationItem.attr("data-has-optional-growth"),
			// coach: $navigationItem.attr("data-has-coach"),
			// military: $navigationItem.attr("data-has-military"),
			// social: $navigationItem.attr("data-has-social"),
			// buddy: $navigationItem.attr("data-has-buddy"),
		};

		// Show/hide each legend item based on data attribute
		Object.keys(dataAttributes).forEach((key) => {
			const $legendItem = $elms.legendItems[key];
			if ($legendItem.length) {
				if (dataAttributes[key] === "1") {
					$legendItem.show();
				} else {
					$legendItem.hide();
				}
			}
		});
	};

	$elms.roleCardNavigationItem.on("click", function () {
		const $this = $(this);
		const dataPhase = $this.attr("data-phase");
		const $target = $elms.spiderChartPhase.filter(
			"[data-phase='" + dataPhase + "']",
		);
		if (!$target.length) {
			return;
		}

		$elms.roleCardNavigationItem.removeClass("is-active");
		$elms.spiderChartPhase.removeClass("is-active");

		$target.addClass("is-active");
		$this.addClass("is-active");

		// Toggle legend items based on the clicked navigation item's data attributes
		toggleLegendItems($this);
	});

	// Initialize legend items based on the active navigation item
	const $activeNavigationItem =
		$elms.roleCardNavigationItem.filter(".is-active");
	if ($activeNavigationItem.length) {
		toggleLegendItems($activeNavigationItem);
	}

	const handleShare = () => {
		const title = window.CFG.strings.shareTitle || "My MDT Results";
		const text = window.CFG.strings.shareText || "Check out my MDT results";
		const url = $elms.shareUrl.val();

		if (navigator.share) {
			navigator
				.share({
					title: title,
					text: text,
					url: url,
				})
				.catch(console.error);
		} else {
			toggleSharePopup();
		}
	};

	const toggleSharePopup = () => {
		const isVisible = $elms.sharePopup.is(":visible");
		$elms.sharePopup.toggle();
		$("body").css("overflow", isVisible ? "" : "hidden");
	};

	const copyUrl = () => {
		$elms.shareUrl.select();
		document.execCommand("copy");

		const originalContent = $elms.copyButton.html();
		$elms.copyButton.html(
			'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>',
		);

		setTimeout(() => {
			$elms.copyButton.html(originalContent);
		}, 2000);
	};

	const shareToSocial = (platform) => {
		const url = encodeURIComponent($elms.shareUrl.val());
		const title = encodeURIComponent(
			window.CFG.strings.shareTitle || "My MDT Results",
		);
		const text = encodeURIComponent(
			window.CFG.strings.shareText || "Check out my MDT results",
		);

		const urls = {
			whatsapp: `https://wa.me/?text=${text}%20${url}`,
			facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
			twitter: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
			linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
		};

		window.open(urls[platform], "_blank");
		toggleSharePopup();
	};

	// Event listeners
	$elms.shareButton.on("click", handleShare);

	$elms.copyButton.on("click", copyUrl);

	// Close popup button
	$elms.closePopup.on("click", toggleSharePopup);

	// Social share buttons
	$(".js-share-whatsapp").on("click", () => shareToSocial("whatsapp"));
	$(".js-share-facebook").on("click", () => shareToSocial("facebook"));
	$(".js-share-twitter").on("click", () => shareToSocial("twitter"));
	$(".js-share-linkedin").on("click", () => shareToSocial("linkedin"));
};
